import React, { useEffect } from 'react'
import clsx from 'clsx'
import { isEmpty } from 'lodash'
import { Box, Collapse } from '@material-ui/core'

import { ChatMessage, LoadingMessage } from './components'
import { NativeScrollbar } from 'components'

import useDaiChat from 'hooks/useDaiChat'

import useStyles from './styles'

const ChatMessages = ({ fixedHeight, ...rest }) => {
  const classes = useStyles()
  const { messages, loading, messagesContainerRef } = useDaiChat()

  const hasMessages = !isEmpty(messages)

  const lastMessage = messages[messages.length - 1]
  const isStreaming = lastMessage?.streaming === true

  useEffect(() => {
    const container = messagesContainerRef.current
    if (!container) return

    const scrollToBottom = () => {
      container.scrollTop = container.scrollHeight
    }

    if (isStreaming || loading) {
      scrollToBottom()
      return
    }

    const distanceFromBottom =
      container.scrollHeight - container.scrollTop - container.clientHeight

    if (distanceFromBottom < 120) {
      scrollToBottom()
    }
  }, [messages, loading, isStreaming, messagesContainerRef])

  return (
    <NativeScrollbar containerRef={messagesContainerRef}>
      <Collapse in={hasMessages} collapsedSize={0}>
        <Box
          {...rest}
          className={clsx(classes.messages, rest?.className)}
          {...(fixedHeight && { style: { height: fixedHeight } })}
          pb={2}
        >
          {messages.map((message, index) => (
            <ChatMessage
              key={message.id || index + 1}
              role={message.role}
              content={message.content}
              streaming={message.streaming}
              phase={message.phase}
              activeToolName={message.activeToolName}
              completedTools={message.completedTools}
            />
          ))}
          {loading && <LoadingMessage />}
        </Box>
      </Collapse>
    </NativeScrollbar>
  )
}

export default ChatMessages
